/**
 * Partial numeric string with optional leading minus (Hip Extension: negative = short of full extension).
 * Strips invalid characters and trims until the value matches a valid partial pattern.
 */
export function sanitizeSignedNumericInput(raw: string): string {
    let s = raw.replace(/[^0-9.\-]/g, '');
    while (s.length > 0 && !/^-?\d*\.?\d*$/.test(s)) {
        s = s.slice(0, -1);
    }
    return s;
}

export function signedNumericInputMode(allowsNegative: boolean | undefined): 'text' | 'decimal' {
    return allowsNegative ? 'text' : 'decimal';
}
